import React from "react";
import { encodeId, slugify } from "../../helper/helperFunction";
import CustomImageComponent from "../../components/CustomImageComponent";
import NotFoundSec from "../pageNotFound/NotFoundSec";
import { t } from "i18next";
import { useCountryPrefix } from "../../routes/useCountryPrefix";
import { useTranslation } from "react-i18next";

const OfferSec = (props) => {
  const countryPrefix = useCountryPrefix();

  const { i18n } = useTranslation();
  const currentLang = i18n.language === "en" ? "" : i18n.language || "";
  const { data } = props

  return (
    <>
      {data ? (
        <section className="property-listing-section projects-section offers-section">
          <div className="container">
            <div className="row">
              {data?.offers?.map((item, index) => {
                return (
                  <div className="col-md-6 col-lg-6" key={index}>
                    <div className="flex-card">
                      <div className="image-block">
                        <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/developers/${slugify(item.developerName)}/project/${slugify(item.projectName)}/${encodeId((item.projectId))}`}>
                          <div className="img-block">
                            <CustomImageComponent
                              src={item.projectThumbnail}
                              alt={item.projectName}
                              className={"img-fluid pro-img"}
                            />
                          </div>
                        </a>
                      </div>
                      <div className="content-block">
                        <div className="pro-details">
                          <div className="">
                            <h4>
                              <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/developers/${slugify(item.developerName)}/project/${slugify(item.projectName)}/${encodeId((item.projectId))}`}>{item.projectName}</a>
                            </h4>
                            <p>
                              <CustomImageComponent
                                src={"/assets/img/location-icon-pin.svg"}
                                alt={"Location"}
                                className={"img-fluid"}
                              />{" "}
                              {item.projectLocation}
                            </p>
                            <p className="pay-text">
                              <span> {item.description}</span>

                            </p>

                          </div>
                        </div>
                        <div className="pro-details">
                          <div className="left-blk">
                            <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/developers/${slugify(item.developerName)}/${encodeId((item.developerId))}`}>

                              <CustomImageComponent
                                src={item.developerThumbnail}
                                alt={item.developerName}
                                className={"img-fluid"}
                              />
                            </a>
                          </div>
                          <div className="right-blk">

                            <a href={`tel:${data.contactDetails.phone}`}>
                              <CustomImageComponent
                                src={"/assets/img/call-icon.svg"}
                                alt={"Phone"}
                                className={"img-fluid"}
                              />
                            </a>
                            <a href={`https://wa.me/${data.contactDetails.whatsApp}`} target="_blank" rel="noopener noreferrer">
                              <CustomImageComponent
                                src={"/assets/img/whatsapp-icon.svg"}
                                alt={"WhatsApp"}
                                className={"img-fluid"}
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      ) : (



        <NotFoundSec title={t("opps")} desc={t("offer_not_found")} img={"/assets/img/not-found.svg"} />

      )}
    </>
  );
};

export default OfferSec;
